import m from "../node_modules/heic2any/dist/heic2any.es.js";
import { U as l } from "../node_modules/utif/UTIF.es.js";
import { ManifoldSchemeClass as a } from "../types/scheme.es.js";
const f = new RegExp(/(mp4|mov|avi|webm|flv|wmv)/, "i"), g = new RegExp(/(obj|fbx|glb|gltf)/, "i"), p = new RegExp(/(gif|png|jpg|jpeg|svg|bmp|tif|tiff|raw)/, "i"), h = new RegExp(/(html)/, "i"), w = new RegExp(/(mp3|wav|aac|ogg|m4a|flac|m4a|)/, "i");
function v(e) {
  try {
    return decodeURIComponent(e) !== e;
  } catch {
    return !1;
  }
}
async function b(e) {
  const s = await (await fetch(e)).blob();
  try {
    const t = await m({
      blob: s,
      toType: "image/png"
    });
    return URL.createObjectURL(t);
  } catch (t) {
    return console.error("HEIC conversion error:", t), "";
  }
}
const I = /[\r\n%#()<>?[\\\]^`{|}]/g, i = "data:image/svg+xml";
function x(e) {
  let n = e;
  const s = e.substring(0, i.length) === i;
  return s && (n = n.substring(i.length)), v(n) ? e : (n = n.replace(/>\s{1,}</g, "><"), n = n.replace(/\s{2,}/g, " "), `${s ? i : ""}${n.replace(I, encodeURIComponent)}`);
}
const u = '[class^="manifold-scheme-"],[class*=" manifold-scheme-"';
function C(e, n = e) {
  let s = n.closest(u), t = !1;
  for (; s; ) {
    const r = s.classList;
    if (r.contains(a.Dark) && (e.classList.add(a.Dark), t = !0), r.contains(a.Light) && (e.classList.add(a.Light), t = !0), t)
      return;
    s = s.parentElement?.closest(u) || null;
  }
}
const y = () => new Promise((e, n) => {
  if (document) {
    if (document.querySelector(
      'script[src*="https://ajax.googleapis.com/ajax/libs/model-viewer"]'
    )) {
      e(!0);
      return;
    }
    const t = document.createElement("script");
    t.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js", t.type = "module", t.onload = function() {
      e(!0);
    }, document.head.appendChild(t);
  }
}), D = async (e, n, s) => {
  const t = n || s;
  if (t)
    if (t.includes("heic")) {
      const r = await b(e);
      if (r)
        return r;
      throw new Error("Unable to convert HEIC to PNG");
    } else return t.includes("svg") && e.startsWith(i) ? x(e) : t.includes("tiff") || t.includes("tif") ? await j(e) : e;
  return e;
}, j = async (e) => {
  const s = await (await fetch(e)).arrayBuffer(), t = l.decode(s);
  l.decodeImage(s, t[0]);
  const r = l.toRGBA8(t[0]), o = document.createElement("canvas");
  o.width = t[0].width, o.height = t[0].height;
  const c = o.getContext("2d");
  if (!c)
    throw new Error("Failed to get canvas context");
  const d = c.createImageData(o.width, o.height);
  return d.data.set(r), c.putImageData(d, 0, 0), o.toDataURL();
}, L = (e) => e ? e.includes("video") ? "video" : e.includes("model") ? "model" : e.includes("img") || e.includes("image") ? "image" : e.includes("audio") ? "audio" : e.includes("html") ? "html" : e.includes("pdf") ? "pdf" : "unknown" : "unknown", U = (e) => e ? f.test(e) ? "video" : g.test(e) ? "model" : p.test(e) ? "image" : w.test(e) ? "audio" : h.test(e) ? "html" : "unknown" : "unknown";
export {
  i as SVGDataPrefix,
  C as applyAncestorSchemeClass,
  b as convertHEICToBase64PNG,
  D as convertPotentialSVGOrHEICOrTIFF,
  x as encodeSVGDataString,
  L as getMediaTypeForContentType,
  U as getMediaTypeForFileExtension,
  y as injectGoogleModelViewer,
  g as is3DModal,
  w as isAudio,
  v as isEncodedURIString,
  h as isHTML,
  p as isImage,
  f as isVideo
};
//# sourceMappingURL=web.es.js.map
